import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { DefaultResponseWithData } from '../models/system';
import { IVoucher } from '../models/Voucher';
import useApiHelper from '../hooks/useApiHelper';

export function useVouchers() {
  const { get, post } = useApiHelper();
  const queryClient = useQueryClient();

  const vouchers = useQuery({
    queryKey: ['vouchers'],
    queryFn: () => get<DefaultResponseWithData<IVoucher[]>>(`/voucher`)
  });

  const create = useMutation(
    (voucher: IVoucher) => post("/voucher", voucher),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["vouchers"]);
      },
    }
  );

  return {
    vouchers,
    create,
  };
}